import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TfPriceComponent } from '@app/modules/tf-pricing/component/price/price.component';
import { FishersciPricingApiService } from '@app/modules/tf-pricing/services/fishersci-pricing-api.service';
import { FishersciPricingService } from '@app/modules/tf-pricing/services/fishersci-pricing.service';
import { HtmlDecodePipe } from '@app/modules/tf-pricing/pipes/html-decode.pipe';
import { ThermofisherPricingService } from '@app/modules/tf-pricing/services/thermofisher-pricing.service';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ThermofisherPricingApiService } from './services/thermofisher-pricing-api.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [
        TfPriceComponent,
        HtmlDecodePipe
    ],
    exports: [
        TfPriceComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        NgbPopoverModule
    ],
    providers: [
        FishersciPricingApiService,
        FishersciPricingService,
        ThermofisherPricingApiService,
        ThermofisherPricingService
    ]
})
export class TfPricingModule {

}
